<app-radio-group
	[items]="fileTypesOptions"
	[(ngModel)]="selectedFileType"
></app-radio-group>
<app-container class="w-4/5 lg:w-3/5 mt-7">
	<div *ngIf="adjustmentDetailsSale && selectedFileType === 'sale'">
		<div
			*ngFor="let adjustment of adjustmentTypes"
			class="grid grid-cols-2 gap-4 mt-8"
		>
			<p class="font-bold grow">{{ adjustment.friendlyName }}</p>
			<app-checkbox
				type="clear"
				[ngModel]="adjustmentDetailsSale[adjustment.value]"
				(ngModelChange)="setAdjustmentDetailsSale($event, adjustment.value)"
				label="Include details in the document"
			></app-checkbox>
		</div>
	</div>
	<div *ngIf="adjustmentDetailsPurchase && selectedFileType === 'purchase'">
		<div
			*ngFor="let adjustment of adjustmentTypes"
			class="grid grid-cols-2 gap-4 mt-8"
		>
			<p class="font-bold grow">{{ adjustment.friendlyName }}</p>
			<app-checkbox
				type="clear"
				[ngModel]="adjustmentDetailsPurchase[adjustment.value]"
				(ngModelChange)="setAdjustmentDetailsPurchase($event, adjustment.value)"
				label="Include details in the document"
			></app-checkbox>
		</div>
	</div>
</app-container>
